import React from 'react';
import { formatMinutesToDuration, parseDurationToMinutes } from '../../utils/duration';

export default function TatMinutesProgress({ totalMinutes = 0, usedMinutes = 0 }) {
  const total = parseDurationToMinutes(totalMinutes);
  const used = parseDurationToMinutes(usedMinutes);
  const remaining = Math.max(0, total - used);
  const remainingLabel = formatMinutesToDuration(remaining) || '0m';
  const percent = total > 0 ? Math.min(100, (used / total) * 100) : 0;

  return (
    <div className="ca-tat-progress" aria-label={`TAT minutes, ${remainingLabel} left`}>
      <div className="ca-tat-progress__row">
        <span className="ca-tat-progress__label">TAT minutes</span>
        <span className="ca-tat-progress__remaining">{remainingLabel} left</span>
      </div>
      <div className="ca-tat-progress__track">
        <div className="ca-tat-progress__fill" style={{ width: `${percent}%` }} />
      </div>
    </div>
  );
}
